import React from "react";

import { Container } from "react-bootstrap";

import { qiuzApi } from "../../../utility/api/apiList";

import useAxios from "../../../hooks/useAxios";

import QuizTab from "../../../components/public/singleSimTabs/quiz";
import LoadingComponent from "../../../components/public/loading";

import { TabContentSection } from "../styledSimContainer";

const QuizTabContainer = ({
  simID,
  simSingleDetail,
  loading,
  error,
  errorMessage,
}) => {
  const {
    loading: quizPostIsLoading,
    error: quizPostError,
    run: runPostQuiz,
  } = useAxios({
    url: qiuzApi,
    params: {
      sim_id: simID,
    },
    method: "post",
  });

  let element = null;

  if (loading) {
    element = <LoadingComponent />;
  } else if (error) {
    element = <p className="text-center fs-4 p-5">{errorMessage}🚶‍♂️</p>;
  } else if (!loading && !simSingleDetail.quizDetail) {
    element = <p className="text-center p-5">بزودی آزمون بارگذاری خواهد شد.</p>;
  } else if (simSingleDetail.quizDetail) {
    element = (
      <QuizTab
        simID={simID}
        quizData={simSingleDetail.quizDetail}
        postQuizRequest={{
          quizPostIsLoading,
          quizPostError,
          runPostQuiz,
        }}
      />
    );
  }

  return (
    <TabContentSection className="py-3">
      <Container>{element}</Container>
    </TabContentSection>
  );
};

export default QuizTabContainer;
